export const EPSILON = 1e-6; // Not Number.EPSILON, matching PlayCanvas's implementation.
